export enum IntroModalType {
  SWIPER = 'swiper',
  IMAGE_SWIPER = 'image-swiper',
}
